import React, { useMemo, useEffect } from 'react';
import { useGLTF, MeshRefractionMaterial } from '@react-three/drei';

const DEFAULT_REFRACTION = {
  // bounces düşük → iç yansıma zinciri kısa → daha az birikimli parlaklık.
  bounces: 2,
  // ior (elmasın fiziksel değeri ~2.42) — aynen bırakıyoruz,
  // dispersion'ı `aberrationStrength` ile kontrol ediyoruz.
  ior: 2.42,
  // fresnel yan kenarlardaki parlak renk şeridini belirliyor;
  // 0.75 → 0.5 ile yan açılardaki renk göz almayacak.
  fresnel: 0.5,
  // aberrationStrength = kromatik sapma (prizma etkisi).
  // 0.018 → 0.007: yeşil/mavi renk sızması gözle görülür azalır
  // ama hâlâ doğal elmas ışık kırınımı hissi kalır.
  aberrationStrength: 0.007,
  fastChroma: true,
  color: '#e8e8e8',
};

export default function DiamondModel({
  path,
  envMap,
  scale = 30,
  position,
  rotation,
  onLoaded,
  refractionConfig,
}) {
  const { scene } = useGLTF(path);

  const meshes = useMemo(() => {
    const list = [];
    scene.updateMatrixWorld(true);
    scene.traverse((child) => {
      if (child.isMesh && child.geometry) {
        list.push({
          geometry: child.geometry,
          matrix: child.matrixWorld.clone(),
        });
      }
    });
    return list;
  }, [scene]);

  useEffect(() => {
    if (onLoaded && scene) {
      onLoaded(scene);
    }
  }, [scene, onLoaded]);

  const config = { ...DEFAULT_REFRACTION, ...(refractionConfig || {}) };

  if (!envMap) return null;

  return (
    <group scale={scale} position={position} rotation={rotation}>
      {meshes.map((m, i) => (
        <mesh
          key={i}
          geometry={m.geometry}
          matrix={m.matrix}
          matrixAutoUpdate={false}
          castShadow
        >
          <MeshRefractionMaterial
            envMap={envMap}
            bounces={config.bounces}
            ior={config.ior}
            fresnel={config.fresnel}
            aberrationStrength={config.aberrationStrength}
            fastChroma={config.fastChroma}
            color={config.color}
            toneMapped={false}
          />
        </mesh>
      ))}
    </group>
  );
}
